/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonValidatorAddressSummaryInfo } from './BabylonValidatorAddressSummaryInfo';

export type BabylonValidatorInfo = {
    VD: BabylonValidatorAddressSummaryInfo;
    STAT: BabylonValidatorInfo.STAT;
    VP: string;
    VPVAL: string;
    VPP: string;
    CUMSH: string;
    PTPPDCNT: string;
    TPLCNT: string;
    PTPPDP: string;
    UTM: string;
    CMS: string;
};

export namespace BabylonValidatorInfo {

    export enum STAT {
        BONDED = 'BONDED',
        INACTIVE = 'INACTIVE',
        JAILED = 'JAILED',
    }


}

